import { endpoint } from "../../../../manage/common/constant"
import { dropdownMapping } from "../../../../manage/common/utils/methods/commonMethods/utilityMethod"
import { departmentDropdown, jobTitleDropdown, jobTypeDropdown, schoolTypeDropdown } from "./constant"
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod"
import { isObjEmpty } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod"
import { updateRequest } from "../../../../manage/edpOps/constant/common"
import { fetchAllPostPromisedData } from "../../../../manage/common/utils/methods/commonMethods/utilityMethod"

export const getDropdowns = async (setDropdowns) => {
    return await Promise.all([
        dropdownMapping(endpoint?.city?.getAll, 'cityDispValue', 'id'),
        dropdownMapping(endpoint?.state?.getAll, 'stateDispValue', 'id'),
        dropdownMapping(endpoint?.country?.getAll, 'countryDispValue', 'id'),
        // dropdownMapping(endpoint?.region?.getAllActive, 'regionDispValue', 'id'),
        dropdownMapping(endpoint.examBoardType.getAllActive, "examBoardTypeDispValue", 'id'),
        dropdownMapping(endpoint.languageMaster.getActiveLanguageMaster, "languageDispValue", 'id'),
        dropdownMapping(endpoint.businessArea.getAllActiveV2, "businessAreaDispValue", 'id', 'businessAreaDesc'),
        // dropdownMapping(endpoint.branch,"languageDispValue",'id'),
    ])

}

export const validatePincode = async (val, setBasicForm = () => { }, dropdowns = {}) => {
    try {
    console.log('dropdowns',dropdowns)
        if (!val || val.length != 6) {
            setBasicForm(prev => ({
                ...prev,
                city: '',
                state: '',
                country: '',
                isValidPin: false
            }))
            return false;
        }
        const data = await fetchAllPromisedData(`${endpoint?.pincode?.getPinCodeDetails}/${val}`,true);
        if(data?.code==200){
            const pincodeCodeDetails=data?.data
        if (isObjEmpty(dropdowns)) 
                return true
        
        else {
            const { city, state, country } = dropdowns;
            console.log('dropdowns,city,state,country',dropdowns)
            setBasicForm(prev => ({
                ...prev,
                city: city.find(city => city.value === pincodeCodeDetails?.cityId),
                state: state.find(state => state.value === pincodeCodeDetails?.stateId),
                country: country.find(country => country.value === pincodeCodeDetails?.countryId),
                isValidPin:true
            }))
        }
    }
    else{
        return false
    }
    } catch (err) {
        console.error(err);
    }
}

export const createSchoolHandler = async (basicDetail = {}, activeContact = [], branchMapping = []) => {
    const reqObj = createRequest(basicDetail, activeContact, branchMapping)
    return await fetchAllPostPromisedData(endpoint.schoolMaster.createSchool, reqObj)
}

export const createRequest = (basicDetail = {}, activeContact = [], branchMapping = []) => {
    const basicDetailObj = updateRequest(basicDetail);
    const activeContactObj = activeContact.map((item) => updateRequest(item));
    const branchMappingObj = branchMapping.map((item) => updateRequest({...item, buCode:{label:item?.bu.label,value:item?.bu.label}}));
    return {
        ...basicDetailObj,
        contacts: activeContactObj,
        branches: branchMappingObj
    }
}
export const editSchoolHandler = async (basicForm,editRowForm, id,updatedObj) => {
    const reqObj = createUpdateRequest(updateRequest(basicForm),editRowForm,updatedObj)
    return await fetchAllPostPromisedData(`${endpoint.schoolMaster.update}/${id}`, {...reqObj,...updatedObj}, 'put')
}

const createUpdateRequest=(basicForm,rowForm,updatedObj)=>{
    const {isBasicFieldsChanged,
        isContactsChanged,
        isBranchMappingChanged}=updatedObj
        if(isBasicFieldsChanged)
            return {...basicForm,cotacts:[],branches:[]}
        else if(isContactsChanged)
            return {...basicForm,contacts:[updateRequest(rowForm)],branches:[]}
        else if(isBranchMappingChanged){
            return {...basicForm,contacts:[],branches:[updateRequest({...rowForm,buCode:{label:rowForm?.bu.label,value:rowForm?.bu.label}})]}
        }
}

export const getLogs = async (id,page=0,pageSize=50) => {
    return await fetchAllPromisedData(`${endpoint.schoolMaster.getLogs}/${id}?offset=${page}&pageSize=${pageSize}`,true)
}

export const getSchoolDetail = async (id) => {
    try {
        // return {"createdBy": "AESL-A16458",
        //     "updatedBy": "AESL-A16458",
        //     "createdOn": "2025-03-26T17:42:24.000+00:00",
        //     "updatedOn": "2025-03-26T17:42:24.000+00:00",
        //     "id": 5,
        //     "name": "Aakash Institue School",
        //     "status": "ACTIVE",
        //     "shortDescription": "A premier institution of India ",
        //     "longDescription": "ABC International School offers a comprehensive curriculum that emphasizes academic excellence, character building, and extra-curricular development.",
        //     "board": 2,
        //     "type": "Co-Educational",
        //     "medium": "English",
        //     "effectiveDate": "2025-03-26T17:42:23.000+00:00",
        //     "country": 1,
        //     "region": 3,
        //     "state": 5,
        //     "city": 3,
        //     "address": "123 Main Street, Downtown",
        //     "pincode": "110005",
        //     "isDeleted": false,
        //     "salesforceId": null,
        //     "websiteId": null,
        //     "contacts": [],
        //     "branches": [
        //         {
        //             "createdBy": "AESL-A16458",
        //             "updatedBy": "AESL-A16458",
        //             "createdOn": "2025-03-26T17:42:25.000+00:00",
        //             "updatedOn": "2025-03-26T17:42:25.000+00:00",
        //             "id": 5,
        //             "bu": 201,
        //             "branch": "East Campus",
        //             "type": "Secondary",
        //             "address": "456 North Road",
        //             "pincode": "654321"
        //         }
        //     ]
        // }
        return await fetchAllPromisedData(`${endpoint?.schoolMaster?.getSchoolById}/${id}`)

    }
    catch (error) {

    }
}
